<template>
  <div id="app">
    <div id="topHalf">
    <!-- <h1>Weight Calculator</h1> -->
    
    <div id="weightWrapper">
      <button @click="reset" id="resetButton">Reset</button>
      <p id="totalWeight"> {{totalWeight}}</p>
      <div id="buttonSelection">
        <button @click="selectingUnit(1)" class="unitSelection unitSelectionPounds"
        :class="{unitSelected:poundsSelected == true}">lbs</button>
        <button @click="selectingUnit(2)" class="unitSelection unitSelectionKilos"
        :class="{unitSelected:poundsSelected == false}">kgs</button>
      </div>
    </div> <!-- end weightWrapper -->
    
    <div id="weightSet">
        <div id="bar"></div>
        
        <div id="plateSlot8L" class="plateLeftOffset"> {{ platesOnBarebell[8] }} </div>
        <div id="plateSlot7L" class="plateLeftOffset"> {{ platesOnBarebell[7] }} </div>
        <div id="plateSlot6L" class="plateLeftOffset"> {{ platesOnBarebell[6] }} </div>
        <div id="plateSlot5L" class="plateLeftOffset"> {{ platesOnBarebell[5] }} </div>
        <div id="plateSlot4L" class="plateLeftOffset"> {{ platesOnBarebell[4] }} </div>
        <div id="plateSlot3L" class="plateLeftOffset"> {{ platesOnBarebell[3] }} </div>
        <div id="plateSlot2L" class="plateLeftOffset"> {{ platesOnBarebell[2] }} </div>
        <div id="plateSlot1L" class="plateLeftOffset"> {{ platesOnBarebell[1] }} </div>
        <div id="plateSlot0L" class="plateLeftOffset"> {{ platesOnBarebell[0] }} </div>
      
        <div id="barbellEndLeft"></div>
        <div id="barbellFade"></div>
          <div id="barbellEndRight"></div>

          <div id="plateSlot0R" class="plateRightOffset"> {{ platesOnBarebell[0] }} </div>
          <div id="plateSlot1R" class="plateRightOffset"> {{ platesOnBarebell[1] }} </div>
          <div id="plateSlot2R" class="plateRightOffset"> {{ platesOnBarebell[2] }} </div>
          <div id="plateSlot3R" class="plateRightOffset"> {{ platesOnBarebell[3] }} </div>
          <div id="plateSlot4R" class="plateRightOffset"> {{ platesOnBarebell[4] }} </div>
          <div id="plateSlot5R" class="plateRightOffset"> {{ platesOnBarebell[5] }} </div>
          <div id="plateSlot6R" class="plateRightOffset"> {{ platesOnBarebell[6] }} </div>
          <div id="plateSlot7R" class="plateRightOffset"> {{ platesOnBarebell[7] }} </div>
          <div id="plateSlot8R" class="plateRightOffset"> {{ platesOnBarebell[8] }} </div>
        
    </div> <!-- end weightSet -->
    </div> <!-- end topHalf -->
    <div id="bottomHalf">
    <h2>Barbell</h2>
    <div id="barbellLabels">
      <div class="barbellStandard">Standard</div>
      <div class="barbellCustom">Custom</div>
    </div>
    <div id="barbellSelection">
      <div class="barbelltest">
        <div class="barbells" v-for="barbell in barbells" :key="barbell.index">
          <button @click="addBarbellWeight(barbell.index), available = true , plateAvailable = false, selected = barbell.index, used(), barbell.isUsed = true, customInUse = false"
          :class="{highlight:barbell.isUsed == true, notactive:barbell.isUsed == false}">
            <span v-if="poundsSelected">{{ barbell.poundWeight }}</span>
            <span v-else>{{ barbell.kiloWeight }}</span>
          </button>
        </div>
      </div> <!-- end barbelltest -->

      <div class="customBarbell">
        <div class="customWeightCircle" v-bind:class="{newCustom:customInUse}">
        <input type="number" v-model="customWeight" class="customWeight"  inputmode="decimal" size="2" placeholder="0" onfocus="{this.value='';}" v-bind:class="{whiteText:customInUse}"/>
        </div>
        <!-- <button id="submit" @click="customInUse = true, addBarbellWeight(parseInt(customWeight)), available = true, plateAvailable = false, selected = true, used()">submit</button> -->
        <button id="submit" @click="customConfirm(parseInt(customWeight))">submit</button>
      </div><!-- end customBarbell -->
    </div>
    
    <h2>Weights</h2>

    <div :class="{ 'plateButtonWrapperDisabled' : available == false}" id="plateButtonWrapper">
      <div v-for="weight in weights" :key="weight.index" class="plateButtons" v-bind:style="{ 'background-color': weight.background }">
        <button v-if="poundsSelected" class="plateButtonPlus" @click="addPlateWeightTwo(weight.poundWeight, weight.plateWidth)">+</button>
        <button v-else class="plateButtonPlus" @click="addPlateWeightTwo(weight.kiloWeight, weight.plateWidth)">+</button>
        <div class="plateButtonDetails">
          <span v-if="poundsSelected">{{ weight.poundWeight }}</span>
            <span v-else>{{ weight.kiloWeight }}</span>
        </div>
        <button v-if="poundsSelected" class="plateButtonMinus" @click="removePlateWeightTwo(weight.poundWeight, weight.plateWidth)">-</button>
        <button v-else class="plateButtonMinus" @click="removePlateWeightTwo(weight.kiloWeight, weight.plateWidth)">-</button>
      </div><!-- end v-for -->
    </div>
  </div> <!-- bottom half -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function() {
    return {
      platesOnBarebell: [],
      plateWidthTotal: 0,
      plateWidthMax: 135,
      selected: false,
      totalWeight: 0,
      barbellWeight: 0,
      plateWeight: 0,
      available: false,
      plateAvailable: false,
      plateMax: false,
      customInUse: false,
      poundsSelected: true,
      customWeight: 0,
      barbells: [
        {
          index: 0,
          poundWeight: 45,
          kiloWeight: 20,
          isUsed: false
        },
        {
          index: 1,
          poundWeight: 35,
          kiloWeight: 15,
          isUsed: false
        },
        {
          index: 2,
          poundWeight: 22,
          kiloWeight: 6.8,
          isUsed: false
        }
      ],
      weights: [
        { poundWeight: 55,
          kiloWeight: 25,
          plateWidth: 23,
          background: '#d5494a'},
        { poundWeight: 45,
          kiloWeight: 20,
          plateWidth: 20,
          background:  '#0088e0'},
        { poundWeight: 35,
          kiloWeight: 15,
          plateWidth: 17,
          background: '#cfce42'},
        { poundWeight: 25,
          kiloWeight: 10,
          plateWidth: 15,
          background: '#5fbe7e'},
        { poundWeight: 15,
          kiloWeight: 5,
          plateWidth: 15,
          background: '#111111' },
        { poundWeight: 10,
          kiloWeight: 2.5,
          plateWidth: 15,
          background: '#111111' },
        { poundWeight: 5.0,
          kiloWeight: 2,
          plateWidth: 15,
          background: '#111111' },
        { poundWeight: 2.5,
          kiloWeight: 1.5,
          plateWidth: 15,
          background: '#111111' },
      ]
    } //end return
  }, //end data
  components: {

  },
  computed: {
   
  },
  methods: {
    reset: function() {
      this.barbellWeight = 0;
      this.customWeight = '';
      this.customInUse = false;
      this.plateWeight = 0;
      this.totalWeight = 0;
      this.platesOnBarebell = [];
      this.resetPlatesOnBarbellCSS();
      this.barbells.forEach(barbell => {
        barbell.isUsed = false;
      });
      this.available = false;
      this.plateMax = false;
      this.plateWidthTotal = 0;
    },
    selectingUnit: function(unit) {
      if(unit == 1) {
        this.poundsSelected = true;
        this.reset();
      }
      else {
        this.poundsSelected = false;
        this.reset();
      }
    },
    customConfirm: function(customWeight) {
      if(customWeight > 0) {
        this.customInUse = true;
        this.available = true;
        this.plateAvailable = false;
        this.selected = true;
        this.used();
        this.barbellWeight = 0;
        this.barbellWeight += customWeight;
        this.totalWeight = this.barbellWeight + this.plateWeight;
        
      }
    },
    addBarbellWeight: function(key) {
      this.barbellWeight = 0;
      if(this.poundsSelected == true) {
        this.barbellWeight += this.barbells[key].poundWeight;
      }
      else {
        this.barbellWeight += this.barbells[key].kiloWeight;
      }
      this.totalWeight = this.barbellWeight + this.plateWeight;
    },

    addPlateWeightTwo: function(weight, width) {
        if(this.available == true) {
          if(this.plateWidthTotal < this.plateWidthMax) {
            this.plateWidthTotal += width;
            this.plateWeight += weight*2;
            this.totalWeight = this.barbellWeight + this.plateWeight;
            this.plateAvailable = false;
            this.platesOnBarebell.push(weight);
            if(this.poundsSelected == true){
            this.testSort();
            }
            else{
              this.testSortKilo();
            }
          }
          else {
            this.plateMax = true;
          }
        }
        else {
        this.plateAvailable = true;
      }
    },
    
    removeFunc: function(array, value) {
      for(var i = array.length - 1; i >= 0; i--) {
            if(array[i] === value) {
                array.splice(i, 1);
                break;
            }
        }
        return array;
    },
    removePlateWeightTwo: function(weight, width) {
      if (this.platesOnBarebell.length == 0) {
          console.log("can't remove a weight that isn't on the bar");
      }
      else {
        if(this.platesOnBarebell.includes(weight)) {
          this.plateWidthTotal = this.plateWidthTotal - width;
          this.plateWeight -= weight*2;
          this.totalWeight = this.barbellWeight + this.plateWeight;
          this.plateAvailable = false;
          this.removeFunc(this.platesOnBarebell, weight);
          if(this.poundsSelected == true){
            this.testSort();
          }
          else{
            this.testSortKilo();
          }
        }
      }
    },

    isDisabled: function() {
        return !this.available;
    },
    availabilty: function(indexHere) {
      this.available = !this.available;
      console.log(indexHere);
    },
    used: function() {
      this.barbells.forEach(barbell => {
        barbell.isUsed = false;
      });
    },
    resetPlatesOnBarbellCSS: function() {
      var i;
      for (i = 0; i < 9; i++) {
      var l = document.getElementById("plateSlot" + i + "L");
      var r = document.getElementById("plateSlot" + i + "R");
      l.setAttribute("class", "plateLeftOffset");
      r.setAttribute("class", "plateRightOffset"); 
      } 
    },
    sortNumber: function(a, b) {
      return a - b;
    },
    testSortKilo: function() {
      this.resetPlatesOnBarbellCSS();
      var arraySorted = this.platesOnBarebell.sort(this.sortNumber).reverse();
      arraySorted.forEach(function(item, index){
        var l = document.getElementById("plateSlot" + index + "L");
        var r = document.getElementById("plateSlot" + index + "R");
          if(item < 10){
            l.classList.add("plate2");
            r.classList.add("plate2");
          }
          else{
            l.classList.add("plate" + item + "K");
            r.classList.add("plate" + item + "K"); 
          } 
      });
    },
    testSort: function() {
      this.resetPlatesOnBarbellCSS();
      var arraySorted = this.platesOnBarebell.sort(this.sortNumber).reverse();
      arraySorted.forEach(function(item, index){
        var l = document.getElementById("plateSlot" + index + "L");
        var r = document.getElementById("plateSlot" + index + "R");
          if(item == 2.5){
            l.classList.add("plate2");
            r.classList.add("plate2");
          }
          else{
            l.classList.add("plate" + item);
            r.classList.add("plate" + item); 
          } 
      });
    }
  }
} //end export
</script>

<style>
</style>